import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { recipes } from '../data/recipes';
import { useTheme } from '../contexts/ThemeContext';

const RecipeList = () => {
  const [selectedType, setSelectedType] = useState<'all' | 'food' | 'drink'>('all');
  const { isDarkMode } = useTheme();

  const filteredRecipes = recipes.filter(
    (recipe) => selectedType === 'all' || recipe.type === selectedType
  );

  return (
    <div className={`min-h-screen py-32 ${isDarkMode ? 'bg-black' : 'bg-stone-50'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <Link
            to="/blog"
            className={`font-serif inline-block px-4 py-2 rounded mb-6 ${
              isDarkMode ? 'bg-gray-700 text-white hover:bg-gray-600' : 'bg-stone-100 text-stone-900 hover:bg-stone-200'
            } transition duration-200`}
          >
            ← Back to Blog
          </Link>
          <h1 className={`font-serif text-5xl font-normal mb-10 ${isDarkMode ? 'text-white' : 'text-stone-900'}`}>Recipes</h1>
          <div className="flex gap-4 mb-10">
            <button
              onClick={() => setSelectedType('all')}
              className={`font-serif px-4 py-2 rounded ${
                selectedType === 'all'
                  ? `${isDarkMode ? 'bg-gray-700 text-white' : 'bg-stone-200 text-stone-900'}`
                  : `${isDarkMode ? 'bg-gray-800 text-gray-300' : 'bg-stone-100 text-stone-500'}`
              }`}
            >
              All
            </button>
            <button
              onClick={() => setSelectedType('food')}
              className={`font-serif px-4 py-2 rounded ${
                selectedType === 'food'
                  ? `${isDarkMode ? 'bg-gray-700 text-white' : 'bg-stone-200 text-stone-900'}`
                  : `${isDarkMode ? 'bg-gray-800 text-gray-300' : 'bg-stone-100 text-stone-500'}`
              }`}
            >
              Food
            </button>
            <button
              onClick={() => setSelectedType('drink')}
              className={`font-serif px-4 py-2 rounded ${
                selectedType === 'drink'
                  ? `${isDarkMode ? 'bg-gray-700 text-white' : 'bg-stone-200 text-stone-900'}`
                  : `${isDarkMode ? 'bg-gray-800 text-gray-300' : 'bg-stone-100 text-stone-500'}`
              }`}
            >
              Drinks
            </button>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredRecipes.map((recipe) => (
              <Link key={recipe.id} to={`/recipes/${recipe.id}`} className="block">
                <motion.div
                  whileHover={{ scale: 1.02 }}
                  className={`${isDarkMode ? 'bg-gray-800' : 'bg-white'} border ${isDarkMode ? 'border-gray-700' : 'border-stone-200'} p-6 rounded-lg`}
                >
                {recipe.imageUrl && (
                  <img
                    src={recipe.imageUrl}
                    alt={recipe.title}
                    className="w-full h-48 object-cover mb-4 rounded"
                  />
                )}
                <h3 className={`font-serif text-xl font-normal mb-2 ${isDarkMode ? 'text-white' : 'text-stone-900'}`}>{recipe.title}</h3>
                {recipe.subtitle && (
                  <p className={`font-serif text-sm ${isDarkMode ? 'text-gray-300' : 'text-stone-500'} mb-3`}>{recipe.subtitle}</p>
                )}
                <div className="flex gap-2 mb-4">
                  <span className={`font-serif px-2 py-1 text-sm ${isDarkMode ? 'bg-gray-700 text-gray-200' : 'bg-stone-100 text-stone-800'} rounded`}>
                    {recipe.cuisine}
                  </span>
                  <span className={`font-serif px-2 py-1 text-sm ${isDarkMode ? 'bg-gray-700 text-gray-200' : 'bg-stone-100 text-stone-800'} rounded`}>
                    {recipe.cookingTime}
                  </span>
                </div>
                <div className={`font-serif text-sm ${isDarkMode ? 'text-gray-400' : 'text-stone-500'}`}>
                  <p className="mb-2">Click to view full recipe.</p>
                </div>
                </motion.div>
              </Link>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default RecipeList;